<script>
export default {
  name: "SnsButton",
  props: {
    theme: {
      type: String,
      default: "primary",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
    loadingLabel: {
      type: String,
      default: "",
    },
  },
  emits: ["click"],
  computed: {
    buttonLoadingLabel() {
      return this.loadingLabel || this.$t("common.loading.loading");
    },
  },
  methods: {
    handleClick() {
      if (!this.disabled && !this.loading) {
        this.$emit("click");
      }
    },
  },
};
</script>

<template>
  <button
    class="rounded"
    :class="`btn btn-${theme} ${customClass}`"
    :disabled="disabled || loading"
    @click="handleClick"
  >
    <template v-if="loading">
      <div class="loading loading-spinner" />
      {{ buttonLoadingLabel }}
    </template>

    <slot v-else />
  </button>
</template>
